import {connect} from 'react-redux';

import {Squid} from "../../components/header/components/Squid";

function mapState(state: any) {
  return {
    client: state.client.data,
  };
}

const actionCreators = {
};

export const SquidContainer = connect(mapState, actionCreators)(Squid);
